/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useEffect, useState } from "react";
import { DonationsTable } from "./DonationsTable";
import { useDonations } from "../../store/useDonations";
import { useLottery } from "../../store/useLottery";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevrons/chevron-down.svg";
import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import { PrimaryButton } from "../../components";

function DonationsScreen() {
  /** Hooks */
  const { allDonations, getAllDonations, downloadDonationsInCSV, hasNextPage } =
    useDonations();
  const { allLotteries, getAllLotteries } = useLottery();

  /** State */
  const [page, setPage] = useState<number>(1);
  const [selectedLottery, setSelectedLottery] = useState<string>("");

  /** Effects */
  useEffect(() => {
    getAllDonations(1, 10);
    getAllLotteries(1, 100); // Get all lotteries for filter
  }, []);

  useEffect(() => {
    setPage(1);
    getAllDonations(1, 10, selectedLottery || undefined);
  }, [selectedLottery]);

  const handleLotteryChange = (lotteryId: string) => {
    setSelectedLottery(lotteryId);
  };

  const selectedLotteryData = allLotteries?.find(
    (lottery) => lottery._id === selectedLottery
  );

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Donations
        </h1>
        <div className="flex gap-3">
          <Menu>
            <MenuHandler>
              <button className="h-10 px-6 bg-white border border-gray-border rounded font-satoshi text-base text-dark font-medium flex items-center justify-center">
                {selectedLottery
                  ? selectedLotteryData?.en_title || "Selected Lottery"
                  : "All"}
                <ChevronDown className="ml-2" />
              </button>
            </MenuHandler>
            <MenuList placeholder={undefined}>
              <MenuItem
                onClick={() => handleLotteryChange("")}
                className="font-satoshi text-base text-dark"
                placeholder={undefined}
              >
                All Lotteries
              </MenuItem>
              {allLotteries?.map((lottery) => (
                <MenuItem
                  key={lottery._id}
                  onClick={() => handleLotteryChange(lottery._id!)}
                  className="font-satoshi text-base text-dark"
                  placeholder={undefined}
                >
                  {lottery.en_title}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
          <Menu>
            <MenuHandler>
              <button className="h-10 px-6 bg-white border border-gray-border rounded font-satoshi text-base text-dark font-medium flex items-center justify-center">
                Download
                <ChevronDown className="ml-2" />
              </button>
            </MenuHandler>
            <MenuList placeholder={undefined}>
              <MenuItem
                onClick={downloadDonationsInCSV}
                className="font-satoshi text-base text-dark"
                placeholder={undefined}
              >
                Download in CSV
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>

      {allDonations && (
        <div className="w-full px-7 py-4 bg-gray-50 border border-gray-border mb-4 rounded">
          <div className="flex justify-between items-center">
            <div>
              <p className="font-satoshi text-sm text-gray-600">
                Total Donations
              </p>
              <p className="font-satoshi text-xl font-bold text-dark">
                {allDonations.totalCount}
              </p>
            </div>
            <div>
              <p className="font-satoshi text-sm text-gray-600">Total Amount</p>
              <p className="font-satoshi text-xl font-bold text-dark">
                ${allDonations.totalAmount.toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!allDonations?.data?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Donation made yet.
          </p>
        ) : (
          <DonationsTable />
        )}
      </div>
      {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              setPage(page + 1);
              getAllDonations(page + 1, 10, selectedLottery || undefined);
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null}
    </div>
  );
}

export default withProtectedRoute(DonationsScreen);
